import WebAPI from './WebAPI'
import AWS from 'aws-sdk'

const API_ROOT_NODE = process.env.API_ROOT_NODE
const API_FOR_XANDR = process.env.API_ROOT_XANDR_NODE
const CONFIG_BUCKET = process.env.CONFIG_BUCKET
const LONG_RUNNING_XANDR_API = process.env.API_LOAD_BALANCER

AWS.config.region = process.env.AWS_REGION || 'us-east-1'
AWS.config.credentials = new AWS.CognitoIdentityCredentials({ IdentityPoolId: process.env.IDENTITY_POOL_ID })
const s3 = new AWS.S3()

class LongRunningXandrAPI extends WebAPI {
  constructor() {
    super({ baseURL: LONG_RUNNING_XANDR_API })
  }

  getQueryCount({ targetDefinition, type, user, caeId }) {
    // timeout is 12 minutes
    return this.__post({
      extensionURL: '/xandr/targetDefinitionQueryCount',
      payload: { targetDefinition, user, type, caeId },
      config: { timeout: 60 * 12 * 1000 },
    })
  }
}

/**
 * Look at the Confluence API article for more information
 * https://audiencematters.atlassian.net/wiki/spaces/AM/pages/448135169/Revision+History
 */
class XandrAPI extends WebAPI {
  constructor() {
    super({ baseURL: API_FOR_XANDR })
    this.long = new LongRunningXandrAPI()
  }

  getTraits(type) {
    return this.__get({ extensionURL: `/Xandr/Traits${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getTrait(id, type) {
    return this.__get({ extensionURL: `/Xandr/Trait/${id}${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getSegments(type) {
    return this.__get({ extensionURL: `/Xandr/Segments${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getSegment(id, type) {
    return this.__get({ extensionURL: `/Xandr/Segment/${id}${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getCampaigns(type, filterByExportEndDate = false) {
    type = type || 'advertising' // default to advertising
    return this.__get({ extensionURL: `/Xandr/Campaign${type ? `?type=${type}` : ''}` })
      .then(resp => resp.data)
      .then(d => {
        if (filterByExportEndDate) {
          let filteredList = []
          let filterOutlist = []
          let todaysDate = new Date()
          for (let c of d) {
            if (c.exportSchedule) {
              if (todaysDate < new Date(c.exportSchedule.exportEndDate)) {
                filteredList.push(c)
              }
            } else {
              filterOutlist.push(c)
            }
          }
          // if you need to sort the filtered list
          // filteredList.sort((a, b) => {
          //   let ad = new Date(a.exportSchedule.exportEndDate)
          //   let bd = new Date(b.exportSchedule.exportEndDate)
          //   if (ad < bd) {
          //     return -1
          //   } else if (ad > bd) {
          //     return 1
          //   } else {
          //     0
          //   }
          // })
          return filteredList
        }
        return d
      })
  }

  getCampaign(id, type) {
    type = type || 'advertising' // default to advertising
    return this.__get({ extensionURL: `/Xandr/Campaign/${id}${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getDestinations(type) {
    return this.__get({ extensionURL: `/Xandr/Destinations${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getDestinationsConfig() {
    return this.__get({ extensionURL: `/Xandr/Destinations/Config` }).then(resp => resp.data)
  }

  getPrimaryInsightsConfig() {
    return this.__get({ extensionURL: `/Xandr/PrimaryInsights/Config` }).then(resp => resp.data)
  }

  getContext(type) {
    return this.__get({ extensionURL: `/Xandr/Context${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getXandrTracing(d, id) {
    let idString = id ? `&id=${id}` : ''
    return this.__get({ extensionURL: `/Xandr/Tracing?date=${d.getTime()}${idString}` }).then(d => d.data)
  }

  getTopLevelTracing(d) {
    return this.__get({ extensionURL: `/Xandr/Tracing/Top?date=${d.getTime()}` }).then(d => d.data)
  }

  getQueryCount({ targetDefinition, type, user, caeId }) {
    return this.long.getQueryCount({ targetDefinition, type, user, caeId })
  }

  async getSegmentationTraits(traitType, type) {
    type = type || 'advertising' // default to advertising
    let key
    switch (traitType) {
      case 'adstra':
        key = `${type}-Adstra-Traits.json.gz`
        break
      case 'prism':
        key = `${type}-Prism-Traits.json.gz`
        break
      case 'dnb':
        key = `${type}-DNB-Traits.json.gz`
        break
      case 'byod':
        key = `${type}-BYOD-Traits.json.gz`
        break
      case 'max':
        key = `${type}-Max-Traits.json.gz`
        break
      case 'tve':
        key = `${type}-ATVE-Traits.json.gz`
        break
      case 'epsilon':
        key = `${type}-EPSILON_EPS-Traits.json.gz`
        break
      case 'd+':
        key = `${type}-DPLUS-Traits.json.gz`
        break
      case 'dcr':
        key = `${type}-DCR-Traits.json.gz`
        break
      default:
        key = `${type}-Adstra-Traits.json.gz`
        break
    }
    const obj = await s3.getObject({ Bucket: CONFIG_BUCKET, Key: key }).promise()
    return JSON.parse(obj.Body.toString())
  }

  // assumes all things are saved in Audience Matters
  sendDownStream({ targetId, user, type }) {
    return this.__post({ extensionURL: '/Xandr/Downstream', payload: { target: { targetId }, user, type } })
    // return fetchSingleTarget({target_id: targetId}).then(resp => {
    //   let t = resp.data
    //   t.activation_status = 'SUBMITTED'
    //   return t
    // })
  }

  getXanderTargetList() {
    return this.__get({
      extensionURL: '/Xandr/TargetList',
    })
  }

  modelLaL({ target }) {
    return this.__post({
      extensionURL: '/Xandr/Model',
      payload: { target },
    })
  }
}

export default new XandrAPI()



// WEBPACK FOOTER //
// ./src/app/api/XandrAPI.js